var isPressing = new WeakSet();
export { isPressing };